/*
 * Placeholder variant guard
 * Blocks Add to Cart / Buy Now when a placeholder option value is still selected
 * (e.g. "Select Size", "Select Dexterity"). Shows an inline warning and disables
 * the purchase buttons until a real option value is chosen.
 */
(function () {
  'use strict';

  var BLOCKED_VALUES = ['select size', 'select dexterity'];
  var MESSAGE = 'Please select a size and dexterity before adding to cart.';
  var DISABLED_LABEL = 'Select an option';

  function isBlocked(value) {
    if (!value) return false;
    return BLOCKED_VALUES.indexOf(String(value).trim().toLowerCase()) !== -1;
  }

  function getSelectedOptionValues(productInfo) {
    var values = [];
    productInfo
      .querySelectorAll('variant-selects input[type="radio"]:checked, variant-radios input[type="radio"]:checked')
      .forEach(function (input) { values.push(input.value); });
    productInfo
      .querySelectorAll('variant-selects select')
      .forEach(function (select) { values.push(select.value); });
    return values;
  }

  function isProductInfoBlocked(productInfo) {
    return getSelectedOptionValues(productInfo).some(isBlocked);
  }

  function applyGuard(productInfo) {
    var blocked = isProductInfoBlocked(productInfo);
    var buttonsWrap = productInfo.querySelector('product-form .product-form__buttons');
    if (!buttonsWrap) return;

    var submitBtn = buttonsWrap.querySelector('button[name="add"]');
    var paymentWrap = buttonsWrap.querySelector('.shopify-payment-button');

    var warning = buttonsWrap.querySelector('.placeholder-variant-warning');
    if (!warning) {
      warning = document.createElement('div');
      warning.className = 'placeholder-variant-warning';
      warning.setAttribute('role', 'alert');
      warning.textContent = MESSAGE;
      buttonsWrap.insertBefore(warning, buttonsWrap.firstChild);
    }

    if (blocked) {
      if (warning.hidden) warning.hidden = false;
      if (submitBtn) {
        if (!submitBtn.hasAttribute('disabled')) submitBtn.setAttribute('disabled', 'disabled');
        submitBtn.setAttribute('aria-disabled', 'true');
        submitBtn.dataset.placeholderBlocked = 'true';
        var label = submitBtn.querySelector('span');
        if (label && !label.dataset.originalLabel) {
          label.dataset.originalLabel = label.textContent;
          label.textContent = DISABLED_LABEL;
        }
      }
      if (paymentWrap) paymentWrap.dataset.placeholderBlocked = 'true';
    } else {
      if (!warning.hidden) warning.hidden = true;
      if (submitBtn && submitBtn.dataset.placeholderBlocked === 'true') {
        delete submitBtn.dataset.placeholderBlocked;
        submitBtn.removeAttribute('aria-disabled');
        var lbl = submitBtn.querySelector('span');
        if (lbl && lbl.dataset.originalLabel) {
          lbl.textContent = lbl.dataset.originalLabel;
          delete lbl.dataset.originalLabel;
        }
        // Don't forcibly remove `disabled` — Shopify controls that for sold-out variants
      }
      if (paymentWrap && paymentWrap.dataset.placeholderBlocked === 'true') {
        delete paymentWrap.dataset.placeholderBlocked;
      }
    }
  }

  function applyGuardToAll() {
    document.querySelectorAll('product-info').forEach(applyGuard);
  }

  function injectStyles() {
    if (document.getElementById('placeholder-variant-guard-style')) return;
    var css = [
      '.placeholder-variant-warning {',
      '  display: block;',
      '  padding: 10px 14px;',
      '  margin-bottom: 12px;',
      '  border: 1px solid rgba(var(--color-foreground), 0.2);',
      '  background: rgba(var(--color-foreground), 0.05);',
      '  color: rgb(var(--color-foreground));',
      '  font-family: var(--font-body-family, sans-serif);',
      '  font-size: 0.9375rem;',
      '  line-height: 1.4;',
      '  border-radius: var(--inputs-radius, 0);',
      '}',
      '.placeholder-variant-warning[hidden] { display: none; }',
      '.shopify-payment-button[data-placeholder-blocked="true"] {',
      '  pointer-events: none;',
      '  opacity: 0.5;',
      '}'
    ].join('\n');
    var style = document.createElement('style');
    style.id = 'placeholder-variant-guard-style';
    style.textContent = css;
    document.head.appendChild(style);
  }

  // Re-check after a variant picker change (Shopify re-renders async, so check twice)
  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest && event.target.closest('variant-selects, variant-radios')) {
      setTimeout(applyGuardToAll, 50);
      setTimeout(applyGuardToAll, 400);
      setTimeout(applyGuardToAll, 900);
    }
  });

  // Hard-block submit via capture-phase listener
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
    var productInfo = form.closest('product-info');
    if (!productInfo) return;
    if (isProductInfoBlocked(productInfo)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  // Hard-block Buy Now / Shop Pay clicks
  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    var paymentWrap = event.target.closest('.shopify-payment-button');
    if (paymentWrap && paymentWrap.dataset.placeholderBlocked === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  function init() {
    injectStyles();
    applyGuardToAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
